import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const createFirmGroup = async ({
  token,
  new_group_name,
}: APIRequest<{
  new_group_name: string;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/add_group',
    'POST',
    {
      new_group_name,
    },
    token,
  );

export const updateFirmGroup = async ({
  token,
  firm_group_id,
  new_group_name,
}: APIRequest<{
  firm_group_id: number;
  new_group_name: string;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/update_group',
    'POST',
    {
      firm_group_id,
      new_group_name,
    },
    token,
  );

export const deleteFirmGroup = async ({
  token,
  firm_group_id,
}: APIRequest<{
  firm_group_id: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/remove_group',
    'POST',
    {
      firm_group_id,
    },
    token,
  );
